export default __webpack_public_path__ + "static/media/about-image-desktop.9388b982.jpg";